module.exports = __webpack_public_path__ + "img/dian.f460d937.png";